module.exports = __webpack_public_path__ + "img/guide_share.bb5290ec.png";